import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/view/index'
import Aside from '@/components/Aside'
import AsidePeople from '@/components/Aside-people'
import Office from '@/components/office'
import OfficeDetail from '@/components/office-detail'
import People from '@/components/people'

Vue.use(Router)

const routes = [
  {
    path: '/',
    redirect: '/index/aside'
  },
  {
    path: '/index',
    name: 'Index',
    component: Index,
    children: [
      {path: '/index/aside', component: Aside},
      {path: '/index/aside-peop', component: AsidePeople},
      {path: '/index/people', component: People},
      {path: '/index/office', component: Office},
      {path: '/index/office-detail', component: OfficeDetail}
    ]
  }
]

export default new Router({
  linkActiveClass: 'active',
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js